export const defaultSeo = {
    title: "SPA Platform - Modern Web Solutions",
    description: "A professional, efficient, and user-friendly platform for building and managing multiple websites from a single codebase.",
    keywords: "website builder, multi-tenant platform, react spa, typescript, white-label solutions",
    tags: "software, technology, innovation, platform",
    author: "Pankaj Kumar Techie",
    faviconUrl: "https://cdn-icons-png.flaticon.com/128/3159/3159310.png",
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
    twitterCard: "summary_large_image",
    twitterTitle: "SPA Platform",
    twitterDescription: "Scalable multi-site management system.",
    twitterImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
    ogTitle: "SPA Platform",
    ogDescription: "Scalable multi-site management system.",
    ogImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
    // Company details
    companyName: "Pankaj Kumar Techie",
    companyUrl: "https://pankaj-kumar-techie.github.io/",
};

export const techieLoondsConfig = {
    companyName: "Techie Loonds",
    tagline: "Innovation in Tech",
    description: "Loonds is a dynamic and innovative software engineering group that specializes in developing cutting-edge technology solutions.",
};
